module.exports = __webpack_public_path__ + "static/media/Instagram.9490b58e.svg";